import { useState } from "react";
import { Loader2, UserCheck, UserPlus } from "lucide-react";
import { toast } from "sonner";
import { useProfile } from "@/context/ProfileContext";
import { errorMessage } from "@/lib/api";

export const FollowButton = ({ profile, onChange }) => {
  const { request } = useProfile();
  const [busy, setBusy] = useState(false);
  const following = profile.is_following;

  const toggle = async () => {
    setBusy(true);
    try { onChange(await request(following ? "delete" : "post", `/users/${profile.user_id}/follow`)); }
    catch (err) { toast.error(errorMessage(err)); } finally { setBusy(false); }
  };

  return (
    <button data-testid="follow-button" onClick={toggle} disabled={busy}
      className={`${following ? "btn-chrome" : "btn-red"} inline-flex items-center gap-2 px-5 py-2.5 text-sm disabled:opacity-70`}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : following ? <UserCheck className="h-4 w-4" /> : <UserPlus className="h-4 w-4" />}
      {following ? "Following" : "Follow"}
    </button>
  );
};
